import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Avatar from '@material-ui/core/Avatar';
import Box from '@material-ui/core/Box';
import Skeleton from '@material-ui/lab/Skeleton';
import ListItemText from '@material-ui/core/ListItemText';
import gravatarUrl from '@afosto/utils/gravatarUrl';
import { users as usersApi } from '@afosto/iam/api/Users';

const UserFormatter = ({ userId }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const fetchUser = async id => {
      setIsLoading(true);

      try {
        const response = await usersApi.getUser(id);
        const { data = null } = response;

        if (isMounted) {
          setUser(data);
        }
      } catch (err) {
        if (isMounted) {
          setUser(null);
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    if (userId) {
      fetchUser(userId);
    } else if (isMounted) {
      setIsLoading(false);
    }

    return () => {
      isMounted = false;
    };
  }, [userId]);

  if (isLoading) {
    return <Skeleton variant="text" />;
  }

  return user ? (
    <Box display="flex" alignItems="center">
      <Box mr={2}>
        <Avatar
          src={gravatarUrl(user?.email, {
            letterValue: `${user?.first_name} ${user?.last_name}`,
          })}
        />
      </Box>
      <ListItemText
        primary={`${user.first_name} ${user.additional_name ? `${user.additional_name} ` : ''}${
          user.last_name
        }`}
        secondary={user.email}
      />
    </Box>
  ) : (
    '-'
  );
};

UserFormatter.propTypes = {
  userId: PropTypes.string,
};

UserFormatter.defaultProps = {
  userId: undefined,
};

export default UserFormatter;
